   $(document).ready(function () {
     $("body").on("click",".filter-item",function(){  
        var selectedValue = $(this).data('value');
      
        $('#SortBy').val(selectedValue);
        $('#SortBy option').each(function () {
          if ($(this).val() === selectedValue) {
            $(this).prop('selected', true);
          }
        });
   
        var element = document.querySelector('#SortBy');
        // 触发input事件
        setTimeout(function () {
      
            if (element.dispatchEvent) {
                // 创建一个input事件对象
                var event = new Event("input", {
                    "bubbles": true,
                    "cancelable": true
                });
                // 分发事件
                element.dispatchEvent(event);
            } else {
                // IE浏览器的旧有方式（不完全等同于input事件触发，仅供参考一种IE下模拟类似操作的思路）
                element.fireEvent("oninput");
            }
     
   },20)
      });
     
    });

 
   
